import styled from 'styled-components';

export const WidgetCaptionContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`;

export const CaptionInfoText = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: calc(100% - 30px);
`;

export const CaptionIcon = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 24px;
    height: 100%;
`;
